import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { fetchAuthSession } from '@aws-amplify/auth';
import { User } from './secure/create-leave-permission/_types/user.model';
import { PermissionService } from './secure/services/permission.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  // title = 'angular';
  // isLoading: boolean = true;
  // username: string = ''
  // success: boolean = false
  // user: User = new User(0, "", "", "", "", "", { name: "", number: "" });
  // message = ''
  // isLoggedIn$ = new BehaviorSubject(false);

  // constructor(private permissionService: PermissionService,
  //   private cdr: ChangeDetectorRef
  // ) { }

  // ngOnInit(): void {
  //   this.getAccount()
  // }

  // account(): User {
  //   return this.user;
  // }

  // getAccount() {
  //   this.isLoading = true
  //   fetchAuthSession()
  //     .then((currentUser: any) => {
  //       this.username = currentUser.tokens?.idToken?.payload['email']
  //       this.permissionService.getAccount(this.username).subscribe(
  //         (user: User) => {
  //           this.isLoading = false
  //           this.success = true
  //           this.user = user;
  //           this.isLoggedIn$.next(true);

  //         },
  //         (err: any) => {
  //           console.log(err)
  //           this.isLoading = false
  //           this.message = 'account not found! please check your email';
  //           this.success = false
  //           this.cdr.detectChanges();
  //         }
  //       )
  //     })
  //     .catch((err: Error) => {
  //       console.log(
  //         'currentUser error',
  //         err.name === 'UserUnAuthenticatedException',
  //       );
  //       this.message = 'No current user please authenticate';

  //       if (err.name === 'UserUnAuthenticatedException') {
  //         this.isLoggedIn$.next(false);
  //       } else if (err.name === 'UserAlreadyAuthenticatedException') {
  //         this.isLoggedIn$.next(true);
  //       } else {
  //         throw err;
  //       }
  //     });
  // }

}
